<template>
  <b-card>

    <!-- media -->
<!--    <b-media no-body>-->
<!--      <b-media-aside>-->
<!--        <b-link>-->
<!--          <b-img-->
<!--            ref="previewEl"-->
<!--            rounded-->
<!--            height="80"-->
<!--          />-->
<!--        </b-link>-->
<!--        &lt;!&ndash;/ avatar &ndash;&gt;-->
<!--      </b-media-aside>-->

<!--      <b-media-body class="mt-75 ml-75">-->
<!--        &lt;!&ndash; upload button &ndash;&gt;-->
<!--        <b-button-->
<!--          v-ripple.400="'rgba(255, 255, 255, 0.15)'"-->
<!--          variant="primary"-->
<!--          size="sm"-->
<!--          class="mb-75 mr-75"-->
<!--          @click="$refs.refInputEl.$el.click()"-->
<!--        >-->
<!--          Upload-->
<!--        </b-button>-->
<!--        <b-form-file-->
<!--          ref="refInputEl"-->
<!--          v-model="profileFile"-->
<!--          accept=".jpg, .png, .gif"-->
<!--          :hidden="true"-->
<!--          plain-->
<!--          @input="inputImageRenderer"-->
<!--        />-->
<!--        &lt;!&ndash;/ upload button &ndash;&gt;-->

<!--        &lt;!&ndash; reset &ndash;&gt;-->
<!--        &lt;!&ndash;        <b-button&ndash;&gt;-->
<!--        &lt;!&ndash;          v-ripple.400="'rgba(186, 191, 199, 0.15)'"&ndash;&gt;-->
<!--        &lt;!&ndash;          variant="outline-secondary"&ndash;&gt;-->
<!--        &lt;!&ndash;          size="sm"&ndash;&gt;-->
<!--        &lt;!&ndash;          class="mb-75 mr-75"&ndash;&gt;-->
<!--        &lt;!&ndash;        >&ndash;&gt;-->
<!--        &lt;!&ndash;          Reset&ndash;&gt;-->
<!--        &lt;!&ndash;        </b-button>&ndash;&gt;-->
<!--        &lt;!&ndash;/ reset &ndash;&gt;-->
<!--        <b-card-text>Allowed JPG, GIF or PNG. Max size of 1MB</b-card-text>-->
<!--      </b-media-body>-->
<!--    </b-media>-->
    <!--/ media -->
    <b-overlay
      :show="mostrarLoader"
      opacity="0.50"
      rounded="sm"
    >
      <div class="text-center items-center con-vs-avatar">
        <b-link>
          <b-img
            ref="previewEl"
            :src="detalleusuario.avatarruta"
            rounded
            height="80"
            class="avatar-img-perfil"
          />
        </b-link>
      </div>
      <div class="text-center">
          <h4>{{ usuario.firstName }} {{ usuario.lastName }}</h4>
      </div>
      <div class="divider">
        <div class="divider-text" style="padding: 0!important;">
        </div>
      </div>
      <div class="flex items-end">
        <feather-icon icon="UserIcon" class="mr-1" />
        <span class="leading-none font-medium">Información Personal</span>
      </div>

      <label class="mt-1">Imagen de perfil</label>

  <!--    <b-col sm="12" lg="12">-->
        <b-input-group>
    <!--      <b-form-input class="custom-file-input" type="file"/>-->
          <input class="custom-file-input-perfil" type="file" @change="gestionarArchivo">
          <b-input-group-append>
              <b-button variant="outline-danger" @click="preguntarEliminarImagen">
                  <feather-icon
                    icon="TrashIcon"
                  />
              </b-button>
          </b-input-group-append>
        </b-input-group>
  <!--    </b-col>-->

      <!-- form -->
      <validation-observer ref="editUserValidation">
        <b-form
          class="edit-user-form mt-2"
          @submit.prevent
        >
          <!-- username -->
          <b-row>
            <b-col sm="6">
              <b-form-group
                label="Nombres"
                label-for="edit-nombres"
              >
                <validation-provider
                  #default="{ errors }"
                  name="nombres"
                  rules="required"
                >
                  <b-form-input
                    id="edit-nombres"
                    v-model="usuario.firstName"
                    placeholder="Ingrese sus nombres"
                    name="nombres"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group
                label="Apellidos"
                label-for="edit-apellidos"
              >
                <validation-provider
                  #default="{ errors }"
                  name="apellidos"
                  rules="required"
                >
                  <b-form-input
                    id="edit-apellidos"
                    v-model="usuario.lastName"
                    placeholder="Ingrese sus apellidos"
                    name="apellidos"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group
                label="E-mail"
                label-for="edit-email"
              >
                <validation-provider
                  #default="{ errors }"
                  name="email"
                  rules="required"
                >
                  <b-form-input
                    id="edit-email"
                    disabled
                    plaintext
                    :value="usuario.email"
                    placeholder="Email"
                    name="email"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
  <!--          <b-col sm="6">-->
  <!--            <b-form-group-->
  <!--              label="Celular"-->
  <!--              label-for="edit-celular"-->
  <!--            >-->
  <!--              <validation-provider-->
  <!--                #default="{ errors }"-->
  <!--                name="celular"-->
  <!--                rules="required"-->
  <!--              >-->
  <!--                <b-form-input-->
  <!--                  id="edit-celular"-->
  <!--                  :value="detalleusuario.celular"-->
  <!--                  placeholder="Celular"-->
  <!--                  name="celular"-->
  <!--                />-->
  <!--                <small class="text-danger">{{ errors[0] }}</small>-->
  <!--              </validation-provider>-->
  <!--            </b-form-group>-->
  <!--          </b-col>-->
            <b-col sm="6">
              <b-form-group
                label="Username"
                label-for="edit-username"
              >
                <validation-provider
                  #default="{ errors }"
                  name="username"
                  rules="required"
                >
                  <b-form-input
                    id="edit-username"
                    disabled
                    plaintext
                    :value="usuario.username"
                    placeholder="Username"
                    name="username"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-button
                id="button-with-loading"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                :disabled="bloqueo_boton"
                variant="primary"
                class="mt-2 mr-1 b-con-loading__container btn-guardar"
                @click="validationForm"
              >
                Guardar
              </b-button>

            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-overlay>
  </b-card>
</template>

<script>
import {
  BFormFile, BButton, BForm, BFormGroup, BFormInput, BRow, BCol, BAlert, BCard, BCardText, BMedia, BMediaAside, BMediaBody, BLink, BImg, BDropdownDivider,  BInputGroupAppend, BInputGroup, BOverlay,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { useInputImageRenderer } from '@core/comp-functions/forms/form-utils'
import { ref } from '@vue/composition-api'
import rutasjson from '@/assets/utils/rutas.json'
import axios from "@/libs/axios";
import actions from "@/assets/utils/utils";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import Vue from "vue";

// const asyncLocalStorage = {
//   setItem(key, value) {
//     return Promise.resolve().then(() => {
//       // localStorage.setItem(key, value);
//       Vue.cookie.set(key, value, { domain: rutasjson.domain, expires: '1Y' })
//     })
//   },
// }

export default {
  components: {
    BButton,
    BForm,
    BImg,
    BFormFile,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BAlert,
    BCard,
    BCardText,
    BMedia,
    BMediaAside,
    BMediaBody,
    BLink,
    BDropdownDivider,
    BInputGroupAppend,
    BInputGroup,
    BOverlay,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  props: {
    generalData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      // optionsLocal: JSON.parse(JSON.stringify(this.generalData)),
      profileFile: null,
      imagen_data: '',
      bloqueo_boton: false,
      activeAlert: false,
      limite_imagen_perfil: 1024, // 1MB
      detalleusuario: JSON.parse(localStorage.getItem('detalleusuario')),
      usuario: JSON.parse(localStorage.getItem('usuario')),
      required,
      mostrarLoader: false,
    }
  },
  computed: {
    // usuario() {
    //   console.log(JSON.parse(this.$store.state.app.user))
    //   return JSON.parse(this.$store.state.app.user)
    // },
    // detalleusuario() {
    //   console.log(JSON.parse(this.$store.state.app.detalleusuario))
    //   return JSON.parse(this.$store.state.app.detalleusuario)
    // },
  },
  methods: {
    validationForm() {
      this.$refs.editUserValidation.validate().then(success => {
        if (success) {
          this.actualizarPerfil()
        }
      })
    },
    actualizarPerfil(){
      actions.bloquearBoton()
      axios.post('api', {
        query: `mutation actualizarPerfil($nombres: String!, $apellidos: String!){
                    actualizarPerfil(nombres:$nombres, apellidos:$apellidos)
                    {
                        status,
                        message,
                    }
                }`,
        variables: {
          nombres: this.usuario.firstName,
          apellidos: this.usuario.lastName,
        },
      }).then(response => {
        if (response.status === 200) {
          if (response.data.data.actualizarPerfil.status === 'success') {
            this.setUserPerfilOnStorageState()
            this.showToast()
          } else {
            this.$swal({
              title: 'Error',
              text: response.data.data.actualizarPerfil.message,
              icon: 'error',
              confirmButtonColor: '#089599',
            })
          }
        }
        actions.desbloquearBoton()
      })
    },
    openLoadingInDiv() {
      this.bloqueo_boton = true
      this.$vs.loading({
        container: '.div-with-loading',
        scale: 0.8,
      })
    },
    closeLoadingInDiv() {
      this.$vs.loading.close('.div-with-loading > .con-b-loading')
      this.bloqueo_boton = false
    },
    resetForm() {
      // this.optionsLocal = JSON.parse(JSON.stringify(this.generalData))
    },
    gestionarArchivo(e){
        const selectedImage = e.target.files[0];
        Math.round((selectedImage.size / this.limite_imagen_perfil));

        if (Math.round((selectedImage.size / this.limite_imagen_perfil)) > this.limite_imagen_perfil) {
            this.$swal({
              title: 'Error',
              text: "Tamaño de imagen no permitido. El peso máximo es de 1MB.",
              icon: 'error',
              confirmButtonColor: '#089599',
            })
            this.imagen_data = '';
        }
        else if(this.checkFileExtension(selectedImage.name)){
            this.$swal({
              title: 'Error',
              text: "Formato de archivo no permitido. Solo se acepta JPG y PNG",
              icon: 'error',
              confirmButtonColor: '#089599',
            })
            this.imagen_data = '';
        }
        else{
            this.createBase64Image(selectedImage);
        }
    },
    checkFileExtension(filename){
        filename = filename.toLowerCase();
        const ext = filename.split('.').pop();
        if(ext!='png' && ext!='jpg' && ext!='jpeg'){
            return true
        }
        return false
    },
    createBase64Image(fileObject){
        const reader = new FileReader();
        reader.onload = (e) => {
            this.imagen_data = e.target.result + ',' + fileObject.name;
            this.guardarImagen();
        };
        reader.readAsDataURL(fileObject);
    },

    guardarImagen(){
      this.mostrarLoader = true
      axios.post('api', {
        query: `mutation cambiarAvatarPerfil($database64: String!){
                   cambiarAvatarPerfil(database64:$database64)
                    {
                        message,
                        status,
                    }
                }`,
        variables: {
          database64: this.imagen_data,
        },
      }).then(response => {
        if (response.status === 200) {
          if (response.data.data.cambiarAvatarPerfil.status === 'success') {
            this.setUserOnStorageState();
            this.showToast()
          } else {
            this.$swal({
              title: 'Error',
              text: response.data.message,
              icon: 'error',
              confirmButtonColor: '#089599',
            })
          }
        }
        this.mostrarLoader = false
      })
    },
    showToast() {
      this.$toast.success({
        component: ToastificationContent,
        props: {
          title: 'Usuario',
          icon: 'InfoIcon',
          text: 'Se ha guardado con éxito la información',
        },
      },
      {
        position: 'bottom-right',
      })
    },
    // setUserOnStorageState(){
    //   this.detalleusuario.avatarruta = this.detalleusuario.avatarruta + '?update=' + String(Math.floor(Math.random() * 100));
    //   asyncLocalStorage.setItem('detalleusuario', JSON.stringify(this.detalleusuario)).then(() => {
    //     let usuario_saved=this.$cookie.get('detalleusuario')
    //     this.$store.commit('app/set_detalleusuario', usuario_saved);
    //   });
    // },
    // setUserPerfilOnStorageState(){
    //   asyncLocalStorage.setItem('usuario', JSON.stringify(this.usuario)).then(() => {
    //     let usuario_saved=this.$cookie.get('usuario')
    //     this.$store.commit('app/set_user', usuario_saved);
    //   });
    // },
    setUserOnStorageState() {
      this.detalleusuario.avatarruta = `${this.detalleusuario.avatarruta}?update=${String(Math.floor(Math.random() * 100))}`
      localStorage.setItem('detalleusuario', JSON.stringify(this.detalleusuario))
      // asyncLocalStorage.setItem('detalleusuario', JSON.stringify(this.detalleusuario)).then(() => {
      //   const usuario_saved = this.$cookie.get('detalleusuario')
      //   this.$store.commit('app/set_detalleusuario', usuario_saved)
      // })
    },
    setUserPerfilOnStorageState() {
      localStorage.setItem('usuario', JSON.stringify(this.usuario))
      // asyncLocalStorage.setItem('usuario', JSON.stringify(this.usuario)).then(() => {
      //   const usuario_saved = this.$cookie.get('usuario')
      //   this.$store.commit('app/set_user', usuario_saved)
      // })
    },
    preguntarEliminarImagen(){
      this.$swal({
        title: 'Eliminación de imagen',
        text: '¿Está seguro que desea eliminar la imagen?',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Eliminar',
        confirmButtonColor: '#d9534f',
      }).then(result => {
        if (result.value) {
          this.eliminarImagen()
        }
      })
    },
    eliminarImagen(){
      this.mostrarLoader = true
      axios.post('api', {
        query: `mutation eliminarAvatarPerfil($tokenPerfil: String!){
                   eliminarAvatarPerfil(tokenPerfil:$tokenPerfil)
                    {
                        message,
                        status,
                    }
                }`,
        variables: {
          tokenPerfil: this.detalleusuario.token,
        },
      }).then(response => {
        if (response.status === 200) {
          if (response.data.data.eliminarAvatarPerfil.status === 'success') {
            this.setUserOnStorageState();
            this.showToast()
          } else {
            this.$swal({
              title: 'Error',
              text: response.data.message,
              icon: 'error',
              confirmButtonColor: '#089599',
            })
          }
        }
        this.mostrarLoader = false
      })
    },
  },
  setup() {
    const refInputEl = ref(null)
    const previewEl = ref(null)

    const { inputImageRenderer } = useInputImageRenderer(refInputEl, previewEl)

    return {
      refInputEl,
      previewEl,
      inputImageRenderer,
    }
  },
}
</script>

<style>
    .con-vs-avatar{
      background: #ffffff!important;
      cursor:auto!important;
    }

    ::file-selector-button {
      display:none!important;
    }

    .custom-file-input-perfil{
      cursor:pointer!important;
      border: 1px solid #d8d6de!important;
      border-radius: 0.357rem;
      flex: 1 1 auto;
      padding: 0.438rem 1rem;
    }

    .avatar-img-perfil{
      cursor:auto!important;
    }
</style>
